module.exports = __webpack_public_path__ + "img/index-comp-pic4.fc79ee20.png";